<template>
  <b-modal :visible="isOpen" @hide="close">
    <template #modal-header>
      <h5>{{ updateData ? $t("EDIT") : $t("NEW") }} {{ $t("PRECARITE") }}</h5>
      <b-button size="sm" @click="close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.028"
          height="17.028"
          viewBox="0 0 17.028 17.028"
        >
          <path
            id="Icon_material-close"
            data-name="Icon material-close"
            d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
            transform="translate(-7.5 -7.5)"
            fill="#393939"
          />
        </svg>
      </b-button>
    </template>

    <form @submit.prevent="savePrecarite">
      <div class="center">
        <b-form-group :label="$t('Code département') + '*'" label-for="code_departement">
          <b-form-input
            id="code_departement"
            v-model="localUpdateData.code_departement"
            aria-describedby="code_departement-feedback"
          ></b-form-input>
          <error-handle
            :list="v$.localUpdateData.code_departement.$errors"
            id="code_departement-feedback"
          ></error-handle>
          <div v-if="erreurlist.code_departement" class="error-message">
            <ul v-if="Array.isArray(erreurlist.code_departement)">
              <span v-for="(e, index) in erreurlist.code_departement" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.code_departement }}</span>
          </div>
        </b-form-group>
        <b-form-group :label="$t('Nom de Département de réalisation de l\'opération') + '*'" label-for="nom_departement">
          <b-form-input
            id="nom_departement"
            v-model="localUpdateData.nom_departement"
            aria-describedby="nom_departement-feedback"
          ></b-form-input>
          <error-handle
            :list="v$.localUpdateData.nom_departement.$errors"
            id="nom_departement-feedback"
          ></error-handle>
          <div v-if="erreurlist.nom_departement" class="error-message">
            <ul v-if="Array.isArray(erreurlist.nom_departement)">
              <span v-for="(e, index) in erreurlist.nom_departement" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.nom_departement }}</span>
          </div>
        </b-form-group>
        <b-form-group :label="$t('Taux précarité') + '*'" label-for="taux_precarite">
          <b-input-group>
            <b-form-input
              id="taux_precarite"
              type="number"
              step="0.01"
              v-model="localUpdateData.taux_precarite"
              aria-describedby="taux_precarite-feedback"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text>%</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <error-handle
            :list="v$.localUpdateData.taux_precarite.$errors"
            id="taux_precarite-feedback"
          ></error-handle>
          <div v-if="erreurlist.taux_precarite" class="error-message">
            <ul v-if="Array.isArray(erreurlist.taux_precarite)">
              <span v-for="(e, index) in erreurlist.taux_precarite" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.taux_precarite }}</span>
          </div>
        </b-form-group>
        <b-form-group :label="$t('Taux classique') + '*'" label-for="taux_classique">
          <b-input-group>
            <b-form-input
              id="taux_classique"
              type="number"
              step="0.01"
              v-model="localUpdateData.taux_classique"
              aria-describedby="taux_classique-feedback"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text>%</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <error-handle
            :list="v$.localUpdateData.taux_classique.$errors"
            id="taux_classique-feedback"
          ></error-handle>
          <div v-if="erreurlist.taux_classique" class="error-message">
            <ul v-if="Array.isArray(erreurlist.taux_classique)">
              <span v-for="(e, index) in erreurlist.taux_classique" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.taux_classique }}</span>
          </div>
        </b-form-group>
        <b-form-group :label="$t('Prix cumac classique') + '*'" label-for="prix_cumac_classique">
          <b-form-input
            id="prix_cumac_classique"
            type="number"
            step="0.01"
            v-model="localUpdateData.prix_cumac_classique"
            aria-describedby="prix_cumac_classique-feedback"
          ></b-form-input>
          <error-handle
            :list="v$.localUpdateData.prix_cumac_classique.$errors"
            id="prix_cumac_classique-feedback"
          ></error-handle>
          <div v-if="erreurlist.prix_cumac_classique" class="error-message">
            <ul v-if="Array.isArray(erreurlist.prix_cumac_classique)">
              <span v-for="(e, index) in erreurlist.prix_cumac_classique" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.prix_cumac_classique }}</span>
          </div>
        </b-form-group>
        <b-form-group
          v-if="showPrixCumacPrecarite"
          :label="$t('prix cumac precarite') + '*'"
          label-for="prix_pr_cumac_classique"
        >
          <b-form-input
            id="prix_pr_cumac_classique"
            type="number"
            step="0.01"
            v-model="localUpdateData.prix_pr_cumac_classique"
            aria-describedby="prix_pr_cumac_classique-feedback"
          ></b-form-input>
          <error-handle
            :list="v$.localUpdateData.prix_pr_cumac_classique.$errors"
            id="prix_pr_cumac_classique-feedback"
          ></error-handle>
          <div v-if="erreurlist.prix_pr_cumac_classique" class="error-message">
            <ul v-if="Array.isArray(erreurlist.prix_pr_cumac_classique)">
              <span v-for="(e, index) in erreurlist.prix_pr_cumac_classique" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.prix_pr_cumac_classique }}</span>
          </div>
        </b-form-group>
     
       
 
      </div>
    </form>

    <template #modal-footer>
      <div class="double">
        <b-button variant="danger" @click="close">{{ $t("CANCEL") }}</b-button>
        <b-button variant="success" @click="savePrecarite">
          <div class="block-spinner">
            {{ $t("SAVE") }}
            <div v-if="getLoadingPrecarite" class="loading ml-2">
              <div class="spinner-border" role="status"></div>
            </div>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import errorHandle from "../ui/errorHandle.vue";
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf, maxLength } from "@vuelidate/validators";

export default {
  props: {
    updateData: Object,
    isOpen: Boolean,
  },
  components: {
    errorHandle,
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  data() {
    return {
      errorS: null,
      erreurlist: {
        code_departement: null,
        nom_departement: null,
        taux_precarite: null,
        taux_classique: null,
        prix_pr_cumac_classique: null,
        prix_cumac_classique: null,
    
      },
      localUpdateData: {
        code_departement: this.updateData?.code_departement || "",
        nom_departement: this.updateData?.nom_departement || "",
        taux_precarite: this.updateData?.taux_precarite || "",
        taux_classique: this.updateData?.taux_classique || "",
        prix_pr_cumac_classique: this.updateData?.prix_pr_cumac_classique || "",
        prix_cumac_classique: this.updateData?.prix_cumac_classique || "",
        
      },
      selectedDelegataires: [],
      selectedEntreprise: null,
      selectedTypesOperations: [],
      typesOperationsOptions: [
        { value: "BAR-EN-101", label: "Isolation de combles ou de toiture" },
        { value: "BAR-EN-102", label: "Isolation des murs" },
        { value: "BAR-EN-103", label: "Isolation d'un plancher" },
        { value: "BAR-EN-104", label: "Fenêtre ou porte-fenêtre complète avec vitrage isolant" },
        { value: "BAR-TH-127", label: "Ventilation mécanique simple flux hygroréglable" },
        { value: "BAR-TH-148", label: "Chauffe-eau thermodynamique à accumulation" },
        { value: "BAR-TH-171", label: "Pompe à chaleur de type air/eau" },
        { value: "BAR-TH-129", label: "Pompe à chaleur de type air/air" },
      ],
    };
  },
  validations() {
    return {
      localUpdateData: {
        code_departement: {
          required,
          maxLength: maxLength(10),
        },
        nom_departement: {
          required,
          maxLength: maxLength(255),
        },
        taux_precarite: {
          required,
        },
        taux_classique: {
          required,
        },
        prix_pr_cumac_classique: {
          required: requiredIf(() => this.showPrixCumacPrecarite),
        },
        prix_cumac_classique: {
          required,
        },
      },
    };
  },

  computed: {
    ...mapGetters([
      "getAllentreprises",
      "getOnlineUser",
      "getLoadingPrecarite",
      "getAllEntitesExternes",
    ]),

    isSuperAdmin() {
      return this.getOnlineUser.role === "user.super-admin";
    },
    showPrixCumacPrecarite() {
      const hasConfigContext = Boolean(this.$route?.query?.configId);
      return Boolean(this.updateData) || !hasConfigContext;
    },
    
    delegatairesOptions() {
      // Filtrer les délégataires (type='delegataire') selon l'entreprise
      const delegataires = (this.getAllEntitesExternes || []).filter(
        (entite) => entite.type === 'delegataire'
      );
      
      if (this.isSuperAdmin) {
        // Pour super-admin : filtrer selon l'entreprise sélectionnée
        if (this.selectedEntreprise) {
          return delegataires.filter(
            (del) => del.entreprise_id === this.selectedEntreprise.id
          );
        }
        return delegataires;
      } else {
        // Pour les autres : filtrer selon l'entreprise de l'utilisateur connecté
        return delegataires.filter(
          (del) => del.entreprise_id === this.getOnlineUser.entreprise.id
        );
      }
    },
  },

  watch: {
    updateData: {
      handler(newVal) {
        if (newVal) {
          this.localUpdateData = { ...newVal };
          
          // Essayer de trouver l'entreprise si la liste est déjà chargée
          if (this.getAllentreprises && this.getAllentreprises.length > 0) {
            this.selectedEntreprise =
              this.getAllentreprises.find(
                (entreprise) => entreprise.id === newVal.entreprise_id
              ) || null;
            
            // Synchroniser localUpdateData.entreprise avec selectedEntreprise pour la validation
            this.localUpdateData.entreprise = this.selectedEntreprise;
          } else {
            // Si les entreprises ne sont pas encore chargées, initialiser à null
            // Le watcher isOpen les chargera et réinitialisera
            this.selectedEntreprise = null;
            this.localUpdateData.entreprise = null;
          }
          
          // Essayer d'initialiser les délégataires si déjà chargés
          const delegataires = (this.getAllEntitesExternes || []).filter(
            (entite) => entite.type === 'delegataire'
          );
          if (newVal.delegataire_ids && Array.isArray(newVal.delegataire_ids) && delegataires.length > 0) {
            this.selectedDelegataires = delegataires.filter((del) =>
              newVal.delegataire_ids.includes(del.id)
            );
          } else {
            this.selectedDelegataires = [];
          }
          
          // Initialiser les types d'opérations
          if (newVal.type && Array.isArray(newVal.type)) {
            this.selectedTypesOperations = this.typesOperationsOptions.filter(option =>
              newVal.type.includes(option.value)
            );
          } else {
            this.selectedTypesOperations = [];
          }
        } else {
          this.localUpdateData = {
            code_departement: "",
            nom_departement: "",
            taux_precarite: "",
            taux_classique: "",
            prix_pr_cumac_classique: "",
            prix_cumac_classique: "",
            delegataire_ids: [],
            entreprise_id: null,
            entreprise: null,
            type: [],
          };
          this.selectedEntreprise = null;
          this.selectedDelegataires = [];
          this.selectedTypesOperations = [];
        }
      },
      immediate: true,
    },
    isOpen: {
      async handler(newVal) {
        if (newVal) {
          // Charger les entreprises si super-admin
          if (this.isSuperAdmin) {
            await this.all_entreprises({
              page: 1,
              per_page: 10000000,
            });
          }
          
          // Charger les délégataires quand le modal s'ouvre
          await this.loadDelegataires();
          
          // Si on est en mode édition, réinitialiser les sélections après le chargement
          if (this.updateData) {
            // Réinitialiser l'entreprise
            this.selectedEntreprise =
              this.getAllentreprises.find(
                (entreprise) => entreprise.id === this.updateData.entreprise_id
              ) || null;
            
            // Synchroniser localUpdateData.entreprise avec selectedEntreprise pour la validation
            this.localUpdateData.entreprise = this.selectedEntreprise;
            
            // Réinitialiser les délégataires après le chargement
            const delegataires = (this.getAllEntitesExternes || []).filter(
              (entite) => entite.type === 'delegataire'
            );
            if (this.updateData.delegataire_ids && Array.isArray(this.updateData.delegataire_ids) && delegataires.length > 0) {
              this.selectedDelegataires = delegataires.filter((del) =>
                this.updateData.delegataire_ids.includes(del.id)
              );
            } else {
              this.selectedDelegataires = [];
            }
            
            // Initialiser les types d'opérations
            if (this.updateData.type && Array.isArray(this.updateData.type)) {
              this.selectedTypesOperations = this.typesOperationsOptions.filter(option =>
                this.updateData.type.includes(option.value)
              );
            } else {
              this.selectedTypesOperations = [];
            }
          } else {
            // Synchroniser localUpdateData.entreprise avec selectedEntreprise pour la validation
            this.localUpdateData.entreprise = this.selectedEntreprise;
          }
        }
      },
    },
    selectedEntreprise: {
      handler(newVal) {
        // Synchroniser avec localUpdateData.entreprise pour la validation
        this.localUpdateData.entreprise = newVal;
        
        if (this.isSuperAdmin && newVal) {
          // Recharger les délégataires quand l'entreprise change pour super-admin
          this.loadDelegataires();
          // Réinitialiser la sélection des délégataires quand on change d'entreprise
          this.selectedDelegataires = [];
        }
      },
    },
  },

  mounted() {
    this.loadDelegataires();
    if (this.isSuperAdmin) {
      this.all_entreprises({
        page: 1,
        per_page: 10000000,
      });
    }
  },

  methods: {
    ...mapActions(["editPrecarite", "storePrecarite", "all_entreprises", "allEntitesExternes"]),

    validateState(name) {
      const { $dirty, $error } = this.v$.localUpdateData[name];
      return $dirty ? !$error : null;
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },

    async savePrecarite() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.errorS = null;
      this.erreurlist = {
        code_departement: null,
        nom_departement: null,
        taux_precarite: null,
        prix_pr_cumac_classique: null,
        prix_cumac_classique: null,
      
      };

      const data = {
        code_departement: this.localUpdateData.code_departement,
        nom_departement: this.localUpdateData.nom_departement,
        taux_precarite: String(this.localUpdateData.taux_precarite ?? ""),
        taux_classique: String(this.localUpdateData.taux_classique ?? ""),
        prix_pr_cumac_classique: this.localUpdateData.prix_pr_cumac_classique,
        prix_cumac_classique: this.localUpdateData.prix_cumac_classique,
        delegataire_ids: this.selectedDelegataires
          ? this.selectedDelegataires.map((del) => del.id)
          : [],
        type: this.selectedTypesOperations
          ? this.selectedTypesOperations.map((option) => option.value)
          : [],
      };

      if (this.isSuperAdmin) {
        data.entreprise_id = this.selectedEntreprise
          ? this.selectedEntreprise.id
          : this.getOnlineUser.entreprise.id;
      } else {
        data.entreprise_id = this.getOnlineUser.entreprise.id;
      }
      const configId = this.$route?.query?.configId;
      if (configId) {
        data.configId = configId;
      }

      if (this.updateData) {
        // Mode édition
        data.id = this.updateData.id;
        try {
          await this.editPrecarite(data);
          this.resetModal();
          this.$emit("confirm", data);
          this.close();
        } catch (err) {
          if (this.isObject(err)) {
            for (const [key, value] of Object.entries(err)) {
              // Mapper les clés de l'API vers les clés du formulaire
              if (key === 'delegataire_ids') {
                this.erreurlist.delegataires = value;
              } else if (key === 'entreprise_id') {
                this.erreurlist.entreprise = value;
              } else {
                this.erreurlist[key] = value;
              }
            }
          } else {
            this.errorS = err;
          }
        }
      } else {
        // Mode création
        try {
          await this.storePrecarite(data);
          this.resetModal();
          this.$emit("confirm", data);
          this.close();
        } catch (err) {
          if (this.isObject(err)) {
            for (const [key, value] of Object.entries(err)) {
              // Mapper les clés de l'API vers les clés du formulaire
              if (key === 'delegataire_ids') {
                this.erreurlist.delegataires = value;
              } else if (key === 'entreprise_id') {
                this.erreurlist.entreprise = value;
              } else {
                this.erreurlist[key] = value;
              }
            }
          } else {
            this.errorS = err;
          }
        }
      }
    },

    close() {
      this.$emit("close");
    },

    resetModal() {
      this.localUpdateData = {
        code_departement: "",
        nom_departement: "",
        taux_precarite: "",
        taux_classique: "",
        prix_pr_cumac_classique: "",
        prix_cumac_classique: "",
        delegataire_ids: [],
        entreprise_id: null,
        entreprise: null,
        type: [],
      };
      this.selectedEntreprise = null;
      this.selectedDelegataires = [];
      this.selectedTypesOperations = [];
      this.erreurlist = {
        code_departement: null,
        nom_departement: null,
        taux_precarite: null,
        taux_classique: null,
        prix_pr_cumac_classique: null,
        prix_cumac_classique: null,
        delegataires: null,
        entreprise: null,
        types_operations: null,
      };
    },
    
    async loadDelegataires() {
      try {
        let entrepriseId = null;
        
        if (this.isSuperAdmin) {
          // Pour super-admin : utiliser l'entreprise sélectionnée
          entrepriseId = this.selectedEntreprise
            ? this.selectedEntreprise.id
            : null;
        } else {
          // Pour les autres : utiliser l'entreprise de l'utilisateur connecté
          entrepriseId = this.getOnlineUser.entreprise.id;
        }
        
        await this.allEntitesExternes({
          page: 1,
          per_page: 10,
          type: 'delegataire',
          entreprise_id: entrepriseId,
        });
      } catch (error) {
        console.error("Error loading delegataires:", error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.option {
  display: flex;
  align-items: center;
  .option__image {
    background-color: #465081;
    padding: 4px;
    max-height: 42px;
    max-width: 42px;
  }
}

.center {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.5rem;
}

::v-deep .modal-body {
  padding: 1rem;
}
</style>

